function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_264",
  "data-name": "Pfad 264",
  d: "M230.516,171.7a9.225,9.225,0,1,1,6.086-16.143,46.782,46.782,0,0,0-91.836-.784,33.766,33.766,0,1,1,0,18.664,46.788,46.788,0,0,0,92.39-4.566A9.19,9.19,0,0,1,230.516,171.7Z",
  transform: "translate(-144.766 -117.326)"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_43",
  "data-name": "Gruppe 43",
  transform: "translate(94.073 34.626)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_265",
  "data-name": "Pfad 265",
  d: "M464.009,238.86a7.12,7.12,0,1,1-7.122-7.122A7.131,7.131,0,0,1,464.009,238.86Zm-7.122-10.522a10.524,10.524,0,1,0,10.524,10.522A10.537,10.537,0,0,0,456.888,228.338Z",
  transform: "translate(-446.363 -228.338)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_266",
  "data-name": "Pfad 266",
  d: "M452.662,259.221a10.187,10.187,0,0,0,0-4.726,8.488,8.488,0,0,0,0,4.726Z",
  transform: "translate(-356.393 -211.71)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_267",
  "data-name": "Pfad 267",
  d: "M402.866,243.464a7.076,7.076,0,1,1-.025-9.054,13.775,13.775,0,0,1,1.665-3.338,10.613,10.613,0,1,0,.08,15.682,13.8,13.8,0,0,1-1.616-3.092C402.937,243.6,402.9,243.531,402.866,243.464Z",
  transform: "translate(-311.313 -193.712)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_268",
  "data-name": "Pfad 268",
  d: "M541.237,238.219c-.387-5.511-4.171-9.881-9.779-9.881-5.569,0-9.322,4.309-9.766,9.765l-.027,11.131h1.008V238.281c.356-4.989,3.708-8.944,8.786-8.944,5.107,0,8.478,4,8.8,9.022h0v10.875h1.007Z",
  transform: "translate(-404.103 -193.712)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_269",
  "data-name": "Pfad 269",
  d: "M185.29,249.2l-.023-10.983c-.387-5.511-4.165-9.881-9.761-9.881a9.519,9.519,0,0,0-9.262,7.185,9.528,9.528,0,0,0-9.271-7.185c-5.559,0-9.3,4.309-9.749,9.765l-.027,11.1H148.2V238.281c.355-4.989,3.7-8.944,8.769-8.944,5.1,0,8.464,4,8.781,9.022h0V239l-.027,10.206h1.033l-.023-10.932c.357-4.984,3.7-8.932,8.769-8.932,5.1,0,8.46,4,8.778,9.022h0V249.2Z",
  transform: "translate(-146.439 -193.712)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_270",
  "data-name": "Pfad 270",
  d: "M600.051,228.338A10.633,10.633,0,1,0,609,244.677h-1.214a9.626,9.626,0,1,1,1.869-6.149h-16.6v1.008l16.591-.023s0,.008,0,.012h1c.01-.185.027-.367.027-.555A10.643,10.643,0,0,0,600.051,228.338Z",
  transform: "translate(-450.725 -193.712)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_271",
  "data-name": "Pfad 271",
  d: "M347.037,260.574v1.008l10.024-.02v-.988Z",
  transform: "translate(-283.945 -215.893)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_272",
  "data-name": "Pfad 272",
  d: "M677.427,249.523c.2-.025.4-.056.6-.092s.39-.078.582-.124c.137-.033.273-.067.408-.105.158-.045.316-.09.471-.141.093-.031.182-.068.273-.1q.446-.162.871-.361l.2-.1a10.631,10.631,0,0,0,1.586-.966l0,0a10.738,10.738,0,0,0,1.244-1.056l-.015-.01a10.764,10.764,0,0,0,1.443-1.79h-1.214a9.782,9.782,0,0,1-1.409,1.53c-.048.042-.095.084-.143.125-.123.1-.247.205-.376.3-.044.034-.091.066-.136.1q-.329.243-.678.457c-.086.053-.174.1-.261.154q-.274.156-.56.295c-.114.055-.23.111-.347.162s-.249.106-.375.154-.277.1-.418.149q-.254.085-.514.157-.2.054-.4.1c-.121.027-.242.056-.365.078-.212.04-.428.071-.646.1-.122.014-.246.024-.37.034-.163.013-.326.02-.491.024-.084,0-.167.008-.252.008a9.637,9.637,0,0,1-9.323-7.266c0-.005,0-.009,0-.013q-.111-.438-.18-.891c-.006-.039-.008-.08-.013-.119-.036-.255-.064-.511-.079-.771l16.275-.02v-.989H666.512l.008-10.2h-1.007l0,10.641c0,.172.018.342.026.511a10.635,10.635,0,0,0,10.605,10.118c.094,0,.184-.012.278-.014.2-.005.389-.014.582-.029C677.144,249.553,677.285,249.54,677.427,249.523Z",
  transform: "translate(-503.082 -193.712)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Pfad_273",
  "data-name": "Pfad 273",
  d: "M296.39,231.542h-1.008v10.29c-.356,4.989-3.708,8.944-8.786,8.944-5.1,0-8.478-3.995-8.791-9.022h0V231.542h-1.007l.025,10.356c.388,5.508,4.17,9.878,9.777,9.878a9.383,9.383,0,0,0,8.786-5.833v5.573c-.356,4.989-3.708,8.945-8.786,8.945a8.483,8.483,0,0,1-8.17-5.961h-1.034a9.5,9.5,0,0,0,9.2,6.961c5.569,0,9.324-4.31,9.766-9.766l.028-12.308h-.021Z",
  transform: "translate(-235.612 -195.916)"
});

var SvgMyConetlogo = function SvgMyConetlogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_44",
    "data-name": "Gruppe 44",
    width: 182.015,
    height: 93.564,
    viewBox: "0 0 182.015 93.564",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyConetlogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my-conet.logo.8be3b3db.svg";
export { ForwardRef as ReactComponent };